export default "__VITE_ASSET__DAhmsaa0__"